import React from "react";
import { cn } from "./cn";

const VARIANT_CLASSES = {
  primary: "bg-btn-arena text-white hover:brightness-110 shadow-md",
  gold: "bg-btn-gold text-ink hover:brightness-105 shadow-md",
  outline: "border-2 border-arena/25 text-arena bg-white hover:bg-arena/5",
  /** Contraste en fondos oscuros (hero / mesh); no usar outline+clases sueltas: cn no hace merge. */
  outlineInverse: "border-2 border-white/55 text-white bg-transparent hover:bg-white/15",
  ghost: "text-ink hover:bg-arena/5",
  danger: "bg-red-600 text-white hover:bg-red-700 shadow-md",
  link: "text-arena underline-offset-4 hover:underline",
};

const SIZE_CLASSES = {
  sm: "text-sm px-3 py-2 rounded-lg",
  md: "text-sm px-4 py-2.5 rounded-xl",
  lg: "text-base px-5 py-3 rounded-xl",
};

export default function Button({
  as = "button",
  variant = "primary",
  size = "md",
  className,
  children,
  disabled = false,
  type = "button",
  ...rest
}) {
  const Comp = as;

  return (
    <Comp
      type={as === "button" ? type : undefined}
      disabled={disabled}
      className={cn(
        "inline-flex items-center justify-center gap-2 font-bold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/70 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed",
        VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.primary,
        SIZE_CLASSES[size] ?? SIZE_CLASSES.md,
        className
      )}
      {...rest}
    >
      {children}
    </Comp>
  );
}
